import { render, staticRenderFns } from "./testModal.vue?vue&type=template&id=7213548f&scoped=true&"
import script from "./testModal.vue?vue&type=script&lang=ts&"
export * from "./testModal.vue?vue&type=script&lang=ts&"
import style0 from "./testModal.vue?vue&type=style&index=0&id=7213548f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7213548f",
  null
  
)

export default component.exports